import ChallengePropagationDialog from './ChallengePropagationDialog';

export default ChallengePropagationDialog;
